import { Quote } from "lucide-react";
import { Reveal } from "./Reveal";
import { TESTIMONIALS } from "../data/testimonials";

export const Testimonials = () => {
    if (!TESTIMONIALS.length) return null;
    return (
        <section className="bg-[#0F1117] border-y border-white/10 py-24" data-testid="testimonials-section">
            <div className="max-w-7xl mx-auto px-4 sm:px-6">
                <Reveal>
                    <p className="font-mono-xp text-[11px] uppercase tracking-[0.3em] text-gray-500 mb-4">The Proof</p>
                    <h2 className="font-display uppercase font-extrabold text-4xl sm:text-5xl tracking-wide text-white leading-none">
                        What Scottish clients <span className="text-[#E53E3E]">say</span>
                    </h2>
                </Reveal>
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10 mt-12">
                    {TESTIMONIALS.map((t, i) => (
                        <Reveal key={i} delay={(i % 3) * 0.06}>
                            <figure className="bg-[#0F1117] p-7 h-full" data-testid={`testimonial-${i}`}>
                                <Quote size={18} className="text-[#E53E3E] mb-4" />
                                <blockquote className="text-gray-300 text-sm leading-relaxed">{t.quote}</blockquote>
                                <figcaption className="mt-5 pt-4 border-t border-white/10">
                                    <span className="block font-display uppercase tracking-wide text-white">{t.name}</span>
                                    <span className="block font-mono-xp text-[10px] uppercase tracking-widest text-gray-500 mt-1">{t.role}</span>
                                </figcaption>
                            </figure>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
